"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _styles = require("@material-ui/core/styles");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Menu = _interopRequireDefault(require("./Menu"));
var _Item = _interopRequireDefault(require("./Item"));
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    container: {
      bottom: 0,
      //avoid cover modal layer
      zIndex: 1000
    },
    root: {
      minWidth: 'auto',
      color: 'white',
      backgroundColor: 'white',
      overflow: 'hidden',
      boxShadow: '0 -2px 6px 2px rgba(0, 0, 0, 0.1)',
      borderRadius: 0,
      padding: 0
    },
    message: {
      padding: 0,
      display: 'flex',
      alignItems: 'center'
    }
  };
});
var BlueCandyBar = function BlueCandyBar(_ref2) {
  var isOpen = _ref2.isOpen,
    _ref2$actions = _ref2.actions,
    actions = _ref2$actions === void 0 ? [] : _ref2$actions,
    _ref2$menuActions = _ref2.menuActions,
    menuActions = _ref2$menuActions === void 0 ? [] : _ref2$menuActions,
    menuRef = _ref2.menuRef;
  var classes = useStyles();
  var hasMenuActions = menuActions.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    classes: {
      root: classes.container
    },
    open: isOpen,
    TransitionComponent: _Slide["default"]
  }, /*#__PURE__*/_react["default"].createElement(_SnackbarContent["default"], {
    classes: {
      root: classes.root,
      message: classes.message
    },
    message: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, actions.filter(function (_ref3) {
      var disabled = _ref3.disabled;
      return !disabled;
    }).map(function (_ref4, index) {
      var label = _ref4.label,
        icon = _ref4.icon,
        onClick = _ref4.onClick;
      return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
        key: index,
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: label
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "pl-4 pr-2"
      }, icon)), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hidden pl-2 pr-4 xl:inline-block"
      }, label));
    }), hasMenuActions && menuActions.filter(function (_ref5) {
      var disabled = _ref5.disabled;
      return !disabled;
    }).length > 0 && /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
      ref: menuRef
    }, function (_ref6) {
      var closeMenu = _ref6.closeMenu;
      return menuActions.filter(function (_ref7) {
        var disabled = _ref7.disabled;
        return !disabled;
      }).map(function (_ref8, index) {
        var label = _ref8.label,
          disabled = _ref8.disabled,
          _onClick = _ref8.onClick;
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index,
          className: "p-3 hover:bg-secondary text-sm cursor-pointer text-medium",
          onClick: function onClick(e) {
            _onClick(e);
            closeMenu();
          }
        }, label);
      });
    }))
  }));
};
var _default = exports["default"] = BlueCandyBar;
//# sourceMappingURL=index.js.map